<template>
    <form-row title="Option Fee Recieved?">
        <div class="flex flex-col sm:flex-row flex-1 sm:items-center">
            <input-radio-boolean
                name="has_received_option_fee"
                v-model="has_received_option_fee"
                true="Yes"
                false="No"
                :read_only="read_only"
            />

            <div class="flex-1 pl-10"
                v-if="has_received_option_fee"
            >
                <input-date
                    class="mt-4 sm:ml-12 sm:-mt-2 sm:-mb-2 flex flex-1 items-center sm:justify-end"
                    label="Date Received:"
                    :value="commercial.option_fee_received_at"
                    name="option_fee_received_at"
                    :read_only="read_only"
                />
            </div>
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        commercial: {},
        read_only: { default: false },
    },

    data() {
        return {
            has_received_option_fee: this.commercial.has_received_option_fee,
        }
    },
}
</script>
